import { render, staticRenderFns } from "./investors.vue?vue&type=template&id=43495bc7&scoped=true&"
import script from "./investors.vue?vue&type=script&lang=js&"
export * from "./investors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43495bc7",
  null
  
)

export default component.exports